export var dateToString = function (date) { var _a, _b; return (_b = (_a = date === null || date === void 0 ? void 0 : date.toISOString()) === null || _a === void 0 ? void 0 : _a.split('T')[0]) !== null && _b !== void 0 ? _b : null; };
export function toInt(str, defaultValue) {
    var result = str ? parseInt(str, 10) : defaultValue;
    return result !== undefined && !isNaN(result) ? result : defaultValue;
}
